<template>
  <v-app>
    <navigation :color="color" :flat="flat" />
    
    <v-main class="pt-0">
      <home />
      <about />
      <features />
      <featurestwo />
      <aboutme />
      <howitworks />
      <!-- <pricing /> -->
      <div id="nada"></div>
      <contact />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <foote />
  </v-app>
</template>

<style scoped>
.v-main {
  background-image: url("~@/assets/img/background_1.webp");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
</style>

<script>
import navigation from "./components/Navigation";
import foote from "./components/Footer";
import home from "./components/HomeSection";
import features from "./components/FeaturesSection";
import featurestwo from "./components/FeaturesSectionTwo";
import about from "./components/AboutSection";
import howitworks from "./components/HowItWorkdsSection";
import aboutme from "./components/AboutMeSection";
import pricing from "./components/PricingSection";
import contact from "./components/ContactSection";

export default {
  name: "App",

  components: {
    navigation,
    foote,
    home,
    features,
    featurestwo,
    about,
    howitworks,
    aboutme,
    contact,
    pricing,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },

  mounted() {
    document.title = "Fisio Viajante";
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    let navigateTo = params.get("nav")

    if (navigateTo) {
      document.getElementById(navigateTo).scrollIntoView();

    }
  },
};
</script>
